import React from 'react';
import { useIntl } from 'react-intl';

export default function CoachChip({ coach, showBio = false, linkToProfile = true, className = '' }) {
  const intl = useIntl();
  if (!coach) return null;
  const content = (
    <div className={`flex items-start gap-3 ${className}`}>
      {coach.avatar_url && <img src={coach.avatar_url} alt={coach.name} className="w-12 h-12 rounded-full" />}
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <h4 className="font-semibold text-succession-text-primary">{coach.name}</h4>
          {coach.verified && <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-succession-primary-10 text-succession-primary text-xs">{intl.formatMessage({ id: 'sprints.coach_chip.verified' })}</span>}
        </div>
        {coach.headline && <p className="text-sm text-succession-text-primary">{coach.headline}</p>}
        {showBio && coach.bio && <p className="text-sm text-succession-text-primary mt-2">{coach.bio}</p>}
      </div>
    </div>
  );
  if (linkToProfile) {
    return (
      <a href={`/coaches/${coach.id}`} className="block rounded-lg -m-3 p-3 hover:bg-succession-hover-bg transition-colors focus:outline-none focus:ring-2 focus:ring-succession-focus-ring">
        {content}
      </a>
    );
  }
  return content;
}


